import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';
import { endpoints } from '../_config/endpoint';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: HttpClient) {}
  public connect() {
    let socket = new SockJS(`${environment.API_URL_V1}/forum`);
    let stompClient = Stomp.over(socket);
    return stompClient;
  }

  getAllNotifications() {
    const params = new HttpParams().set('page', '1').set('size', '10');
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.allNotifications}`,
      { params }
    );
  }

  readNotification(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.allNotifications}/${id}/read`
    );
  }

  getAllMessages() {
    const params = new HttpParams().set('page', '1').set('size', '10');
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.receivedMessages}`,
      { params }
    );
  }
}